import { render, staticRenderFns } from "./ContactLayoutCustomInfoHeader.vue?vue&type=template&id=13e33764&scoped=true"
import script from "./ContactLayoutCustomInfoHeader.vue?vue&type=script&lang=js"
export * from "./ContactLayoutCustomInfoHeader.vue?vue&type=script&lang=js"
import style0 from "./ContactLayoutCustomInfoHeader.vue?vue&type=style&index=0&id=13e33764&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e33764",
  null
  
)

export default component.exports